import { Node } from "@contentful/rich-text-types"
import EmailValidator from "email-validator"
import { get } from "lodash"
import React from "react"
import { ContentfulButton } from "../../../graphql-types"
import { ContentfulButtonType, DownloadButton } from "../../types"
import {
  BasicButtonLink,
  DisabledButtonLink,
  InvertedButtonLink,
  TextLink,
  UpperscoredTextLink,
} from "../../ui/components/link/link.component"

const isEmail = (url: string) => EmailValidator.validate(url)
export const resolveIsEmail = (url: string) =>
  isEmail(url) ? `mailto:${url}` : url

export const getEmbedFields = (node: Node) => get(node, "data.target")
export const isButton = (node: any): boolean => {
  const fields = getEmbedFields(node)
  return (
    (fields as ContentfulButton).url !== undefined &&
    (fields as ContentfulButton).text !== undefined
  )
}

export const mapEmbeddedEntryToButton = (node: Node) => {
  const fields = getEmbedFields(node)
  return {
    url: resolveIsEmail(fields.url),
    text: fields.text,
    context: fields.context,
    type: fields.type,
  }
}

export const mapEmbeddedEntryToButtonLink = (node: Node) => {
  const button = mapEmbeddedEntryToButton(node)
  if (button.type === ContentfulButtonType.UppercasedLink) {
    return (
      <TextLink to={button.url} aria-label={button.context}>
        {button.text}
      </TextLink>
    )
  } else if (button.type === ContentfulButtonType.UppercasedLinkBelowText) {
    return (
      <UpperscoredTextLink to={button.url} aria-label={button.context}>
        {button.text}
      </UpperscoredTextLink>
    )
  } else if (button.type === ContentfulButtonType.InvertedButton) {
    return (
      <InvertedButtonLink to={button.url} aria-label={button.context}>
        {button.text}
      </InvertedButtonLink>
    )
  } else if (button.type === ContentfulButtonType.DisabledButton) {
    return (
      <DisabledButtonLink to={button.url} aria-label={button.context}>
        {button.text}
      </DisabledButtonLink>
    )
  }
  return (
    <BasicButtonLink to={button.url} aria-label={button.context}>
      {button.text}
    </BasicButtonLink>
  )
}

export const isDownloadButton = (node: any): boolean => {
  const fields = getEmbedFields(node)
  return Boolean((fields as DownloadButton).windowsUrl)
}

export const isAudio = (node: any): boolean => {
  const fields = getEmbedFields(node)
  return Boolean(fields.tracks?.length)
}

export const isAnchor = (node: any): boolean => {
  const fields = getEmbedFields(node)
  return Boolean(fields.anchorId)
}

export const mapEmbeddedEntryToDownloadButton = (node: Node) => {
  const fields = getEmbedFields(node)
  return {
    macUrl: fields.macUrl,
    windowsUrl: fields.windowsUrl,
    linuxUrl: fields.linuxUrl,
    googlePlayUrl: fields.googlePlayUrl,
    appStoreUrl: fields.appStoreUrl,
  }
}

export const mapEmbeddedEntryToAudio = (node: Node) => {
  const fields = getEmbedFields(node)
  return {
    tracks: fields.tracks?.map((track: any) => ({
      title: track.title,
      url: track.file.url,
    })),
  }
}

export const mapEmbeddedEntryToAnchor = (node: Node) => {
  const fields = getEmbedFields(node)
  return {
    anchorId: fields.anchorId,
  }
}
